<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Passageiros em lote</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            { text: 'Home', disabled: false, to: '/home', exact: true },
                            { text: 'Passageiros em lote', disabled: true, exact: true },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(['passenger-imports.create'])" id="btnNew" type="button" color="primary"
                            elevation="0" to="/passageiros-lote/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="6" md="5">
                                    <v-text-field dense id="file_name" label="Planilha"
                                        v-model="dataList.filter.file_name" hide-details outlined
                                        clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-select dense outlined hide-details clearable label="Status"
                                        :items="statusOptions" v-model="dataList.filter.status"></v-select>
                                </v-col>

                                <v-col cols="12" sm="6" md="3" class="d-flex align-center">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                    <v-btn class="ml-2" color="primary" outlined elevation="2"
                                        @click="dataList.filter = {}; load()">Limpar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma importação encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.customer`]="{ item }">
                                {{ item.customer ? item.customer.name : '-' }}
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate('DD/MM/YYYY HH:mm') }}
                            </template>

                            <template v-slot:[`item.processed_at`]="{ item }">
                                <template v-if="item.processed_at">{{ item.processed_at | defaultDate('DD/MM/YYYY HH:mm') }}</template>
                                <template v-else>-</template>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small dark :color="statusColor(item.status)">
                                    {{ statusLabel(item.status) }}
                                </v-chip>
                                <span v-if="item.status === 3 && item.error_rows > 0"
                                    class="ml-2 caption grey--text">{{ item.success_rows }} de {{ item.total_rows }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon v-on="on" @click="viewItem(item)" size="large">
                                            mdi-eye-outline
                                        </v-icon>
                                    </template>
                                    <span>Ver detalhes</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PassengerImportList",

    data: () => ({
        dataList: {
            filter: {},
            headers: [
                { text: "Planilha", value: "file_name" },
                { text: "Empresa", value: "customer" },
                { text: "Criado em", value: "created_at" },
                { text: "Processado em", value: "processed_at" },
                { text: "Status", value: "status" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ["id"],
                sortDesc: [true],
            },
            footerOptions: {
                itemsPerPageText: "Itens por página:",
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: "{0}-{1} de {2}",
            },
        },

        statusOptions: [
            { text: "Pendente", value: 1 },
            { text: "Processando", value: 2 },
            { text: "Concluído", value: 3 },
            { text: "Erro", value: 4 },
        ],

        // Recarrega sozinho enquanto houver importação em andamento
        pollTimer: null,
    }),

    created() {
        this.load();
    },

    beforeDestroy() {
        this.stopPolling();
    },

    methods: {
        statusLabel(status) {
            const found = this.statusOptions.find((s) => s.value === status);

            return found ? found.text : "-";
        },

        statusColor(status) {
            if (status === 3) return "success";
            if (status === 4) return "error";
            if (status === 2) return "info";

            return "grey";
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.dataList.options.page = 1;
            this.load();
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        viewItem(item) {
            this.$router.push(`/passageiros-lote/${item.id}`);
        },

        startPolling() {
            if (this.pollTimer) return;

            this.pollTimer = setInterval(() => this.load(true), 8000);
        },

        stopPolling() {
            if (!this.pollTimer) return;

            clearInterval(this.pollTimer);
            this.pollTimer = null;
        },

        async load(silent = false) {
            if (!silent) this.dataList.loading = true;

            try {
                const search = Object.fromEntries(
                    Object.entries(this.dataList.filter).filter(([, v]) => v !== null && v !== "")
                );

                const response = await axios.get("api/v2/passenger-imports", {
                    params: {
                        page: this.dataList.options.page,
                        limit: this.dataList.options.size,
                        search: search,
                    },
                });

                const content = response.data.content;

                this.dataList.data = content.data || [];
                this.dataList.count = content.total || 0;

                // Enquanto algo estiver pendente ou processando, segue atualizando
                const running = this.dataList.data.some((i) => i.status === 1 || i.status === 2);

                if (running) this.startPolling();
                else this.stopPolling();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>
